import { render, staticRenderFns } from "./BaixarRelatorioControleSaldos.vue?vue&type=template&id=f65b8c42&scoped=true"
import script from "./BaixarRelatorioControleSaldos.vue?vue&type=script&lang=js"
export * from "./BaixarRelatorioControleSaldos.vue?vue&type=script&lang=js"
import style0 from "./BaixarRelatorioControleSaldos.vue?vue&type=style&index=0&id=f65b8c42&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65b8c42",
  null
  
)

export default component.exports